<template>
  <div>
    <v-app>
      <Alert />
      <!-- Top nav -->
      <AppBar @drawer="drawer = !drawer" />
      <!-- Left nav -->
      <v-navigation-drawer app v-model="drawer" temporary clipped>
        <v-list
          nav
          :dense="this.$vuetify.breakpoint.name === 'xs' ? true : false"
          class="pa-0"
        >
          <!-- User info -->
          <div class="left-nav__info-background">
            <v-list-item>
              <v-img
                v-if="userDistributorId == '646d024a6e770f61219d2e3c'"
                :src="require('@/assets/img/agromich-logo-footer.png')"
                width="100px"
                height="100px"
                contain
              ></v-img>
              <v-img
                v-else
                width="100px"
                height="100px"
                contain
                :src="require('@/assets/img/ic_launcher_final_foreground.png')"
              ></v-img>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="list-item__content-text">
                  {{ user.name }} {{ user.lastName }}
                </v-list-item-title>
                <v-list-item-subtitle class="list-item__content-white">{{
                  user.email
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-btn text class="btn-profile" @click="profile">{{
                translations.label_profile
              }}</v-btn>
            </v-list-item>
          </div>

          <v-divider class="mb-5" />

          <!-- Nav items -->
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            :to="item.to"
            link
            @click="clear"
          >
            <v-list-item-icon>
              <v-icon v-if="item.icon" class="ml-1">{{ item.icon }}</v-icon>
              <v-img
                v-else
                :src="require(`@/assets/img/${item.img}`)"
                width="35"
                height="35"
                class="pa-0 ma-0"
              ></v-img>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-if="item.text !== translations.label_download_sampling_app"
                v-text="item.text"
              ></v-list-item-title>
              <v-list-item-title v-else
                ><a
                  href="https://play.google.com/store/apps/details?id=com.solena.app_comercial_android&hl=es_MX"
                  >{{ item.text }}</a
                ></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- Logout -->
        <template v-slot:append>
          <v-row class="justify-center">
            <v-col cols="3" class="py-0">
              <v-btn-toggle
                divided
                color="primary"
                v-model="langSelected"
                density="compact"
                class="justify-center"
              >
                <div v-for="(lang, index) in langs" :key="index">
                  <v-btn @click="updateLamguage(lang.id)">
                    <v-img
                      width="30px"
                      class="mx-auto"
                      :src="lang.icon"
                    ></v-img>
                  </v-btn>
                </div>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" align="center">
              <v-img
                :height="userDistributorId == '646d024a6e770f61219d2e3c' ? '25px':'50px'"
                :width="userDistributorId == '646d024a6e770f61219d2e3c' ? '100px':'200px'"
                contain
                :src="require('@/assets/img/cmda_logo.png')"
              ></v-img>
            </v-col>
          </v-row>

          <v-btn
            block
            color="secondary"
            class="logout-button text-caption text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
            @click="dialogLogOut = true"
            :loading="loading"
          >
            {{ translations.menu_log_out }}
          </v-btn>
        </template>
      </v-navigation-drawer>

      <!-- Content -->
      <v-main class="main_app">
        <div>
          <v-container fluid class="my-0 py-0" v-if="client.length > 0">
            <v-row
              class="text-center my-0 py-0"
              style="background-color: white"
            >
              <v-col class="my-0 py-0">
                <span>
                  {{ client }}
                </span>
              </v-col>
            </v-row>
          </v-container>
          <router-view></router-view>
        </div>
      </v-main>

      <!-- Dialog -->

      <v-dialog v-model="dialogLogOut" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6">
            {{ translations.label_confirmation }}
          </v-card-title>
          <v-card-text>{{ translations.logout_message }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogLogOut = false">
              {{ translations.cancel }}
            </v-btn>
            <v-btn color="green darken-1" text @click="logOut">
              {{ translations.acept }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showExpireSessionModal" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6">
            {{ translations.label_session_expired }}</v-card-title
          >
          <v-card-text>{{ translations.label_relogin }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="logOut">
              {{ translations.acept }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Footer -->
      <!-- <Footer v-if="areaSelected && currentPath === '/territory'" /> -->

      <!-- copyright -->
      <!-- <div
        v-if="currentPath !== '/territory' && currentPath !== '/areasList'"
        class="fix-down"
        :class="
          currentPath === '/territory/addLogbook'
            ? 'copyright--green'
            : 'copyright'
        "
      >
        D.R. © Solena Ag, Inc. Av. Olímpica 3020-D Villas de San Juan 37295,
        León Gto, México. 2021
      </div> -->
      <ChangeLanguageModal
        v-model="showChangeLanguageModal"
        v-if="showChangeLanguageModal"
      />
    </v-app>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//Components
import AppBar from "@/components/AppBar";
import TerritoryInfo from "@/components/territory/TerritoryInfo";
import Footer from "@/components/Footer";
import Alert from "@/components/Alert";
import ChangeLanguageModal from "@/components/home/modals/ChangeLanguageModal.vue";

export default {
  components: {
    AppBar,
    TerritoryInfo,
    Footer,
    Alert,
    ChangeLanguageModal,
  },
  data() {
    return {
      drawer: false,
      title: "Solena",
      user: {},
      loading: false,
      dialogLogOut: false,
      items: [],
      // variables
      currentPath: "",
      isAreaSelected: false,
      logBook: false,
      showUser: true,
      shouldShow: true,
      showExpireSessionModal: false,
      actuallyDate: new Date(),
      showChangeLanguageModal: false,
      langs: [
        {
          id: "en",
          name: "English",
          icon: require("@/assets/img/usa-flag.jpeg"),
        },
        {
          id: "pt",
          name: "Português",
          icon: require("@/assets/img/brazil-flag.png"),
        },
        {
          id: "es",
          name: "Español",
          icon: require("@/assets/img/mexico-flag.png"),
        },
        {
          id: "es-pr",
          name: "Español (Perú)",
          icon: require("@/assets/img/peru_flag.png"),
        },
      ],
      langSelected: 0,
      userDistributorId: null,
    };
  },
  async created() {
    if (this.language == "en") {
      this.langSelected = 0;
    } else if (this.language == "es") {
      this.langSelected = 2;
    } else if (this.language == "pt") {
      this.langSelected = 1;
    }else if (this.language == "es-pr") {
      this.langSelected = 3;
    }
    await this.setSessionExpire();
  },
  async mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role != "ORG_USER" && user.role != "ORG_USER_ADMIN") {
      this.userDistributorId = localStorage.getItem(
        "distributionOrganizationId"
      );
    }
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", "en");
    }
    window.setInterval(async () => {
      this.actuallyDate = new Date();
      // }, (1000 * 60) * 5 )
    }, 1000 * 60);
    this.loadMenu();
  },
  computed: {
    ...mapState("session", ["language"]),
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected"]),
    ...mapState("user", ["client"]),
    ...mapGetters("profile", ["getDataProfile"]),
    ...mapState("session", ["authenticatedUser", "permissions"]),

    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "50px";
        case "sm":
          return "50px";
        case "md":
          return "50px";
        case "lg":
          return "50px";
        case "xl":
          return "50px";
      }
    },
    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "200px";
        case "sm":
          return "200px";
        case "md":
          return "200px";
        case "lg":
          return "200px";
        case "xl":
          return "200px";
      }
    },
  },
  watch: {
    areaSelected(value) {
      if (value) {
        this.isAreaSelected = true;
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu",
          });
        } else {
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu_seller",
            funcLeftButton: this.goBack,
          });
        }
      } else {
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu",
            rightButton: "listAreas",
          });
        } else {
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu_seller",
            funcLeftButton: this.goBack,
            rightButton: "listAreas",
          });
        }
        this.isAreaSelected = false;
      }
    },
    getDataProfile() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    drawer() {
      // let canvas = document.getElementsByTagName("canvas");
      // if (canvas.length > 0) {
      //   let frame = canvas[0];
      //   frame.style.top = "0px";
      // }
    },
    async actuallyDate() {
      await this.setSessionExpire();
    },
  },
  methods: {
    ...mapActions("session", ["changeLanguage"]),
    updateLamguage(lang) {
      this.changeLanguage(lang);
      this.$router.go(0);
    },
    async closeInfo() {
      this.drawer = !this.drawer;

      let navDrawer = document.getElementsByTagName("nav")[0];
      let overlays = await document.getElementsByClassName("v-overlay");
      let overlay = overlays[0];
      navDrawer.style.visibility = "hidden";
      overlay.style.visibility = "hidden";

      setTimeout(() => {
        this.drawer = !this.drawer;
        navDrawer.style.visibility = "";
        overlay.style.visibility = "";
      }, 1000);
    },
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("profile", ["SET_PROFILE"]),
    ...mapMutations("samples", [
      "SET_SAMPLE_SELECTED",
      "SET_SAMPLES",
      "SET_AREA_SELECTED_SAMPLE",
    ]),
    ...mapMutations("logs", ["CLEAR_STATE"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapActions("session", ["logout", "getNewToken"]),
    ...mapActions("user", ["sessionExpire"]),
    ...mapMutations("session", ["UPDATE_USER_INFO"]),
    goBack() {
      this.$router.push(`/seller-list/client/`);
    },
    async logOut() {
      await this.logout();
      this.clear();
      this.$router.push("/login");
    },
    clear() {
      this.SET_SAMPLE_SELECTED(null);
      this.CLEAR_STATE();
      this.SET_SAMPLES([]);
      this.SET_AREA_SELECTED_SAMPLE(null);
      this.SET_AREA_SELECTED(null);
    },
    profile() {
      this.$router.push(`/profile`);
    },
    async setSessionExpire() {
      try {
        let response = await this.sessionExpire();

        if (response) {
          if (response.code == 1) {
            // session expire
            this.showExpireSessionModal = true;
          } else if (response.code == 0) {
            // not expire
            this.UPDATE_USER_INFO(response);
            this.loadMenu();
          }
        }
      } catch (error) {
        console.log(error.message);
      }
    },
    loadMenu() {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.role == "ORG_USER") {
        this.shouldShow = false;
        this.items = [
          {
            icon: "mdi-home-variant",
            text: this.translations.label_territory,
            to: "/territory",
          },
          {
            img: "icon_sample.svg",
            text: this.translations.menu_samples,
            to: "/samples",
          },
          {
            icon: "mdi-chart-box",
            text: this.translations.label_results,
            to: "/analysis-list",
          },
          // {
          //   img: "icon_log_fields.svg",
          //   text: "Bitácora",
          //   to: "/logbook",
          // },
          {
            icon: "mdi-currency-usd",
            text: this.translations.label_profitability,
            to: "/profit-list",
          },
        ];
      } else {
        this.items = [
          {
            icon: "mdi-home-variant",
            text: this.translations.label_territory,
            to: "/territory",
          },
          {
            img: "icon_sample.svg",
            text: this.translations.menu_samples,
            to: "/samples",
          },
          {
            icon: "mdi-chart-box",
            text: this.translations.label_results,
            to: "/analysis-list",
          },
          // {
          //   img: "icon_log_fields.svg",
          //   text: "Bitácora",
          //   to: "/logbook",
          // },
          {
            icon: "mdi-map-marker-off",
            text: this.translations.label_no_georeference,
            to: "/samples-not-geo",
          },
        ];
      }
      if (
        this.permissions.find(
          (permission) => permission == "sampler_manage_profits"
        )
      ) {
        this.items.push({
          icon: "mdi-currency-usd",
          text: this.translations.label_profitability,
          to: "/profit-list",
        });
      }
      if (
        this.permissions.find(
          (permission) => permission == "sampler_manage_projects"
        )
      ) {
        this.items.push({
          icon: "mdi-home-silo",
          text: this.translations.label_projects,
          to: "/proyects-list",
        });
      }

      this.items.push({
        icon: "mdi-download",
        text: this.translations.label_download_sampling_app,
        to: "",
      });
    },
  },
};
</script>

<style scoped>
.logout-button {
  border-radius: 0;
}
.list-item__content-white {
  color: white !important;
}
.list-item__content-text {
  color: white !important;
  font-weight: bold !important;
}
.btn-profile {
  color: #337affe5 !important;
  font-weight: bold !important;
}

.fix-down {
  width: 100%;
  position: absolute;
  margin: 2% 0;
  bottom: 0;
  text-align: center;
}
</style>
